import React from 'react';

const PageTopStyleBg = () => {
    return (
        <div>
            <div className="left-top-bg"></div>
            <div className="right-bottom-bg"></div>
        </div>
    );
};

export default PageTopStyleBg;